import React, { useEffect } from "react";
import {
    APPOINTMENT_PROGRESS_BAR,
    DEFAULT_PROGRESS_BAR,
    MARKETING_PROGRESS_BAR
} from "./selectors";
import styles from "./styles.css";
import getTwoDigitNumber from "../../../utils/helpers/get-two-digit-number";
import PropTypes from "prop-types";

const mapping = {
    default: JSON.parse(JSON.stringify(DEFAULT_PROGRESS_BAR)),
    oneStep: JSON.parse(JSON.stringify(APPOINTMENT_PROGRESS_BAR)),
    marketing: JSON.parse(JSON.stringify(MARKETING_PROGRESS_BAR))
};

const LeadProgressBar = ({
    type = "default",
    data,
    setProgressBarDataConnect
}) => {

    useEffect(() => {
        setProgressBarDataConnect(mapping[type]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getHeadingStyle = (item) => {
        let style = "";
        if (item.visited) {
            style = "styles.visited";
        } else if (item.active) {
            style = "styles.active";
        }
        return style;
    };

    const renderHeadings = () => (
        data.map((item, index) => {
            return (
                <div key={index} styleName={`styles.steps ${getHeadingStyle(item)}`}>
                    <span styleName={"styles.numberText"}>{getTwoDigitNumber(index + 1)}</span>
                    <div>
                        {item.label}
                    </div>
                </div>

            );
        })
    );

    const getWidth = (subItems) => {
        const width = 100;
        const length = Object.keys(subItems).length;
        const ar = [];
        Object.keys(subItems).forEach(item => {
            if (subItems[item]) ar.push(item);
        });
        return Math.abs((width / length) * (ar.length));
    };

    const renderBar = () => {
        return data.map((item, index) => {
            if (item.children) {
                return (
                    <div key={index} styleName={"styles.barContainer"}>
                        <div
                            styleName={"styles.progress"}
                            style={{ width: `${getWidth(item.children)}%` }} />
                    </div>
                );
            }
            return null;
        });
    };

    return (
        data &&
        <div>
            <div styleName={"styles.bar"}>
                {renderBar()}

            </div>
            <div styleName={"styles.headingContainer"}>
                {renderHeadings()}
            </div>

        </div>
    );
};

LeadProgressBar.propTypes = {
    type: PropTypes.string,
    data: PropTypes.array,
    setProgressBarDataConnect: PropTypes.func
};

export default LeadProgressBar;
